/* =========================================================================
   MORINGA UTOPIA — theme.js
   No framework, no dependencies. Everything degrades to a working page
   without JS: forms post natively, links navigate, details/summary open.
   ========================================================================= */
(function () {
  'use strict';

  var MU = window.MU || {};
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- 1. HEADER SHADOW + STICKY OFFSET ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  // The header sticks below the announcement bar; its height can change with
  // wrapping, so measure it rather than hardcoding.
  var announce = $('.announce');
  function setAnnounceH() {
    document.documentElement.style.setProperty('--announce-h',
      (announce ? Math.round(announce.getBoundingClientRect().height) : 0) + 'px');
  }
  setAnnounceH();
  window.addEventListener('resize', setAnnounceH);

  /* ---------- 2. MOBILE NAV ---------- */
  var mnav = $('[data-mnav]');
  if (mnav) {
    var openNav = function () {
      mnav.hidden = false;
      requestAnimationFrame(function () { mnav.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var first = mnav.querySelector('a, button');
      if (first) first.focus();
    };
    var closeNav = function () {
      mnav.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () { mnav.hidden = true; }, 340);
    };
    $$('[data-mnav-open]').forEach(function (b) { b.addEventListener('click', openNav); });
    $$('[data-mnav-close]').forEach(function (b) { b.addEventListener('click', closeNav); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !mnav.hidden) closeNav();
    });
  }

  /* ---------- 3. CART DRAWER ---------- */
  var drawer = $('[data-cart-drawer]');
  var scrim  = $('[data-cart-scrim]');
  var lastFocus = null;

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    if (scrim) scrim.hidden = false;
    window.setTimeout(function () {
      drawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
    }, 10);
    document.body.style.overflow = 'hidden';
    drawer.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      drawer.hidden = true;
      if (scrim) scrim.hidden = true;
    }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (scrim) scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeCart();
  });

  var checkoutBtn = $('[data-cart-checkout]');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.getAttribute('aria-disabled') === 'true') return;
      window.location.href = '/checkout';
    });
  }

  /* ---------- 4. CART STATE ---------- */
  function refreshCart() {
    return fetch('/?sections=cart-items', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-items'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var meter = doc.querySelector('[data-render-meter]');
        var lines = doc.querySelector('[data-render-lines]');
        var total = doc.querySelector('[data-render-total]');
        var count = doc.querySelector('[data-render-count]');

        var meterMount = $('[data-ship-meter-mount]');
        var bodyMount  = $('[data-cart-body]');
        var totalMount = $('[data-cart-total]');

        if (meter && meterMount) meterMount.innerHTML = meter.innerHTML;
        if (lines && bodyMount)  bodyMount.innerHTML  = lines.innerHTML;
        if (total && totalMount) totalMount.textContent = total.textContent.trim();

        if (count) {
          var n = parseInt(count.textContent.trim(), 10) || 0;
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = n;
            el.hidden = n === 0;
          });
          if (checkoutBtn) {
            if (n === 0) checkoutBtn.setAttribute('aria-disabled', 'true');
            else checkoutBtn.removeAttribute('aria-disabled');
          }
        }
        // Any inline meter elsewhere on the page (sticky bar, announcement)
        if (meter) {
          $$('[data-ship-meter-inline]').forEach(function (el) { el.innerHTML = meter.innerHTML; });
        }
      });
  }

  function setLoading(form, on) {
    var btn = form ? form.querySelector('button[type="submit"]') : null;
    if (btn) btn.classList.toggle('is-loading', !!on);
  }

  /* Add to cart — every [data-ajax-cart] form */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    setLoading(form, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () { setLoading(form, false); openCart(); })
      .catch(function (err) {
        setLoading(form, false);
        var msg = (err && err.description) ? err.description : 'Could not add that to your cart.';
        var slot = form.querySelector('[data-cart-error]');
        if (slot) { slot.textContent = msg; slot.hidden = false; }
        else window.alert(msg);
      });
  });

  /* Quantity + remove inside the drawer */
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(refreshCart);
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { changeLine(rm.dataset.lineKey, 0); return; }

    var up = e.target.closest('[data-qty-up]');
    var dn = e.target.closest('[data-qty-down]');
    if (up || dn) {
      var wrap = (up || dn).closest('.qty');
      var input = wrap ? wrap.querySelector('input') : null;
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      var next = up ? val + 1 : Math.max(0, val - 1);
      input.value = next;
      if (input.dataset.lineKey) changeLine(input.dataset.lineKey, next);
      else input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input][data-line-key]');
    if (!input) return;
    changeLine(input.dataset.lineKey, parseInt(input.value, 10) || 0);
  });

  /* ---------- 5. VARIANT PICKER ---------- */
  $$('[data-variant-picker]').forEach(function (root) {
    // The JSON payload sits after the section markup, outside the picker
    // element — fall back to a document-level lookup or the picker silently
    // no-ops and the wrong variant gets added to the cart.
    var jsonEl = $('[data-variant-json]', root) || $('[data-variant-json]');
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var inputs   = $$('input[name="id"][type="radio"]', root);
    var idField  = $('[data-variant-id]', root);
    var priceEl  = $('[data-variant-price]', root);
    var econEl   = $('[data-variant-econ]', root);
    var submitEl = $('[data-variant-submit]', root);

    function apply(variantId) {
      var v = data.variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (econEl && v.econ_html) econEl.innerHTML = v.econ_html;
      if (submitEl) {
        submitEl.disabled = !v.available;
        var label = submitEl.querySelector('.btn__label');
        if (label) label.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      // Keep the URL shareable without adding history entries
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('variant:change', { detail: v, bubbles: true }));
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () { apply(input.value); });
    });
  });

  /* ---------- 6. STICKY BUY BAR ---------- */
  var sticky = $('[data-stickybuy]');
  // Observe the buy box itself, not the zero-height [data-buy-anchor] sentinel.
  // The previous pairing - a target with no height plus a rootMargin that
  // flattens the root to a single line at the top of the viewport - is
  // degenerate: isIntersecting is false at every scroll position the browser
  // samples, so no threshold is ever crossed, the callback ran once at
  // registration and never again, and the bar stayed hidden for the whole
  // page. A real element with real height genuinely crosses the viewport
  // edge and reports it.
  var buyBox = $('.pdp__form') || $('[data-buy-anchor]');
  var showSticky = function (on) {
    if (sticky) sticky.classList.toggle('is-visible', !!on);
  };
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        showSticky(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(buyBox);
  } else if (sticky && buyBox) {
    // Older in-app webviews without IntersectionObserver still get the bar.
    var syncSticky = function () {
      showSticky(buyBox.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);
    syncSticky();
  }
  // The footer reserves space so this fixed bar never sits on top of content.
  // Measure rather than hard-code: the bar's height moves with the type scale
  // and with long product titles, and a stale constant silently under-reserves.
  if (sticky) {
    var publishBarHeight = function () {
      document.documentElement.style.setProperty(
        '--stickybuy-h', Math.ceil(sticky.getBoundingClientRect().height) + 'px');
    };
    publishBarHeight();
    window.addEventListener('resize', publishBarHeight);
    if ('ResizeObserver' in window) new ResizeObserver(publishBarHeight).observe(sticky);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(publishBarHeight);
  }

  /* ---------- 7. REVEAL + COUNT-UP ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Auto-tag common blocks so every template gets scroll reveals without
  // markup changes. Siblings inside one parent get a 60ms stagger (capped).
  var AUTO_REVEAL = ['.rule-head', '.card', '.fmt__card', '.prov__step', '.res__item',
                     '.blog__card', '.blog__lead', '.figure-block', '.email-cap__box',
                     '.pstory__ledger', '.art__rel-card', '.prov__closing',
                     '.res__honesty', '.trans__disclose'];
  if (!reduceMotion) {
    $$(AUTO_REVEAL.join(',')).forEach(function (el) {
      // Anything already inside the initial viewport must never wait for an
      // observer tick - above-the-fold content stays visible.
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.6 && r.bottom > 0) return;
      if (!el.classList.contains('reveal')) {
        el.classList.add('reveal');
        var sibs = el.parentElement ? [].slice.call(el.parentElement.children) : [];
        var idx = sibs.indexOf(el);
        if (idx > 0) el.style.setProperty('--reveal-delay', Math.min(idx * 60, 300) + 'ms');
      }
    });
  }

  var reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
    // Fail-safe: whatever happens to the observer, nothing may stay hidden.
    // After 4s every un-revealed element is shown; off-screen items are out
    // of view anyway, so the effect is invisible when the observer works.
    window.setTimeout(function () {
      $$('.reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
    }, 4000);
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Count-up: animate the numeric part of a figure the first time it is seen.
  // "R1,000" counts 0 to 1,000 keeping prefix and commas.
  function countUp(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^([^0-9]*)([\d.,]+)(.*)$/);
    if (!m) return;
    var target = parseFloat(m[2].replace(/,/g, ''));
    if (!isFinite(target) || target === 0) return;
    var decimals = (m[2].split('.')[1] || '').length;
    var hasComma = m[2].indexOf(',') > -1;
    var t0 = null, DUR = 900;
    function fmt(v) {
      var str = v.toFixed(decimals);
      if (hasComma) str = str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return m[1] + str + m[3];
    }
    function tick(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / DUR, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = raw;
    }
    requestAnimationFrame(tick);
  }
  var counters = $$('[data-countup]');
  if (counters.length && !reduceMotion && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { countUp(entry.target); cio.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- 8. ACCORDION — one open at a time per group ---------- */
  $$('[data-acc-exclusive]').forEach(function (group) {
    $$('details', group).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        $$('details', group).forEach(function (other) { if (other !== d) other.open = false; });
      });
    });
  });

})();
